export default __webpack_public_path__ + "static/man-fba540b0ce2491c687049e8368439de0.png";